import { render } from "./AwaitableEdge.vue?vue&type=template&id=4c357a13&ts=true"
import script from "./AwaitableEdge.vue?vue&type=script&lang=ts&setup=true"
export * from "./AwaitableEdge.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/connect-flow/components/flow/edges/AwaitableEdge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c357a13"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c357a13', __exports__)) {
    api.reload('4c357a13', __exports__)
  }
  
  module.hot.accept("./AwaitableEdge.vue?vue&type=template&id=4c357a13&ts=true", () => {
    api.rerender('4c357a13', render)
  })

}


export default __exports__